<style scoped>
  .folder{
    margin: 15px 10px;
    padding: 10px 30px;
    border: 1px solid #ddd;
    min-height:650px;
  }
  .folder ul li div{
    height: 120px;
  }
  .folder .file{
    cursor: pointer;
  }
</style>
<template>
  <div>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="/course/classinFolder">课程管理</Breadcrumb-item>
        <Breadcrumb-item><a @click="getFolderTop()">Classin文件目录</a></Breadcrumb-item>
        <Breadcrumb-item v-for="(item,index) in accountList"><a @click="queryAgentMember(item.id)">{{item.name}}</a></Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="folder">
      <Form :label-width="60">
        <Row :gutter="12">
          <i-col :md="3">
            <div @dblclick="onSearchTop" :onLoading="onLoading"  v-if="state" class="file">
              <Icon type="folder" size="100"></Icon>
              <p>classin目录</p>
            </div>
          </i-col>
          <ul align="center">
            <li v-for="item in folderList" @dblclick="getFolderId(item.folderId, item.folderName)" class="file">
              <i-col :span="3">
                <Icon type="folder"  size="70"></Icon>
                <p>{{item.folderId}} -- {{item.folderName}}</p>
              </i-col>
            </li>
            <li v-for="item in fileList" v-if="!state">
              <i-col :span="3">
                <Icon type="document-text"  size="70"></Icon>
                <p align="center">{{item.id}} --{{item.fileName}}</p>
              </i-col>
            </li>
          </ul>
        </Row>
      </Form>
    </div>
  </div>
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {
        state: true,
        fileList: [],
        folderList: [],
        Account: '',
        name: '',
        accountList: [],
      }
    },
    created () {
      this.getFolderTop()
    },
    methods: {
      search (acc, name) {
        // 解决双击问题
        let list = this.accountList
        if (list.length > 0 && list[list.length - 1].id === acc) {
          return
        }
        if (acc) {
          let floder = {}
          floder.name = name
          floder.id = acc
          this.accountList.push(floder)
        }
      },
      // 面包屑导航点击查询实时变更函数
      queryAgentMember (account) {
        let floderList = this.accountList
        let newArr = []
        for (let i in floderList) {
          if (floderList[i].id === account) {
            newArr.push(floderList[i])
            break
          }
          if (floderList[i].id !== account) {
            newArr.push(floderList[i])
          }
        }
        this.accountList = newArr
        this.folderId = account
        this.onSearchTop()
      },
      getFolderTop () {
        let self = this
        self.state = true
        this.accountList = []
        this.folderList = []
        this.fileList = []
        self.$http.get('/classinFile/getTopFile').then(function (res) {
          if (res && res.data) {
            self.folderId = res.data
          }
        })
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      getFolderId (value, name) {
        let self = this
        self.onSearch(value, name)
      },
      onSearch (value, name) {
        this.state = false
        this.search(value, name)
        this.$http.get('/classinFile/getCloudFileList?folderId=' + value).then((res) => {
          if (res.data) {
            this.fileList = res.data.fileList
            this.folderList = res.data.folderList
          }
        })
      },
      onSearchTop () {
        this.state = false
        this.$http.get('/classinFile/getCloudFileList?folderId=' + this.folderId).then((res) => {
          if (res.data) {
            this.fileList = res.data.fileList
            this.folderList = res.data.folderList
          }
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// ClassinFolder.vue?e10fc51a